import { defaultDataIdFromObject, InMemoryCache, makeVar } from '@apollo/client'
import { uniqBy } from 'lodash'

const cache = new InMemoryCache({
    typePolicies: {
        Query: {
            fields: {
                bosSaving () {
                    return bosSavingVar()
                },
                appError () {
                    return appErrorVar()
                },
                navHistory () {
                    return navHistoryVar()
                },
                notifications () {
                    return notificationsVar()
                },
                modals () {
                    return modalsVar()
                },
                scrollTarget () {
                    return scrollTargetVar()
                },
                events: {
                    keyArgs: ['vehicleId', 'filter'],
                    read (data) {
                        return data
                    },
                    merge: (existing = { __typename: 'EventList', events: [] }, incoming) => {
                        return {
                            ...incoming,
                            events: uniqBy(
                                [
                                    ...existing.events,
                                    ...incoming.events,
                                ],
                                '__ref'
                            ),
                        }
                    }
                }
            }
        },
        Event: {
            fields: {
                eventData: {
                    merge: true,
                },
            },
        },
        Bos: {
            fields: {
                seller: {
                    merge: true,
                },
                buyer: {
                    merge: true,
                },
                pricePayment: {
                    merge: true,
                },
                vehicle: {
                    merge: true,
                },
            },
        },
        Options: {
            fields: {
                car: {
                    merge: true,
                },
                bike: {
                    merge: true,
                },
                caravan: {
                    merge: true,
                },
                machine: {
                    merge: true,
                },
                boat: {
                    merge: true,
                },
                part: {
                    merge: true,
                },
            },
        },
    },
    dataIdFromObject: object => {
        switch (object.__typename) {
        case 'NettixAccessory': return `Option_accessories:${object.fi}` // use `fi` as the primary key
        default: return defaultDataIdFromObject(object)
        }
    }
})

export const bosSavingVar = makeVar(false)
export const appErrorVar = makeVar(null)
export const navHistoryVar = makeVar({ historyIndex: 0, history: [] })
export const notificationsVar = makeVar([])
export const modalsVar = makeVar([])
export const scrollTargetVar = makeVar(null)

export default cache
